import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

const isDevelopment = import.meta.env.DEV;

// Mock data for development
const mockInterviewers = [
  {
    id: 1,
    created_at: new Date().toISOString(),
    name: 'Sales Associate AI',
    company: 'Demo Corp',
    status: 'active',
    embed_code: '',
    interviews_count: 5,
    last_active: new Date().toISOString(),
    url: 'http://localhost:5173/interview/1',
    vapi_assistant_id: 'demo-assistant-1',
    vapi_api_key: 'demo-key-1'
  },
  {
    id: 2,
    created_at: new Date().toISOString(),
    name: 'Customer Service AI',
    company: 'Support Inc',
    status: 'active',
    embed_code: '',
    interviews_count: 3,
    last_active: new Date().toISOString(),
    url: 'http://localhost:5173/interview/2',
    vapi_assistant_id: 'demo-assistant-2',
    vapi_api_key: 'demo-key-2'
  }
];

function createMockClient() {
  console.warn('Using mock Supabase client for development');
  return {
    from: () => ({
      select: () => Promise.resolve({ data: mockInterviewers, error: null }),
      insert: (data) => Promise.resolve({ data: { ...data, id: Date.now() }, error: null }),
      update: (data) => Promise.resolve({ data, error: null }),
      delete: () => Promise.resolve({ data: null, error: null }),
      eq: () => ({
        single: () => Promise.resolve({ data: mockInterviewers[0], error: null })
      }),
      ilike: () => ({
        single: () => Promise.resolve({ data: mockInterviewers[0], error: null })
      }),
      order: () => Promise.resolve({ data: mockInterviewers, error: null })
    }),
    storage: {
      from: () => ({
        upload: () => Promise.resolve({ data: null, error: null }),
        download: () => Promise.resolve({ data: null, error: null }),
        remove: () => Promise.resolve({ data: null, error: null }),
      }),
    },
  };
}

// Export the appropriate client based on environment
export const supabase = isDevelopment && (!supabaseUrl || !supabaseAnonKey)
  ? createMockClient()
  : createClient(supabaseUrl, supabaseAnonKey);

export type Database = {
  public: {
    Tables: {
      interviewers: {
        Row: {
          id: number;
          created_at: string;
          name: string;
          company: string;
          status: 'active' | 'paused';
          embed_code: string;
          interviews_count: number;
          last_active: string | null;
          vapi_assistant_id: string;
          vapi_api_key: string;
          url: string;
        };
        Insert: Omit<Database['public']['Tables']['interviewers']['Row'], 'id' | 'created_at' | 'interviews_count' | 'last_active'>;
        Update: Partial<Database['public']['Tables']['interviewers']['Insert']>;
      };
    };
  };
};